<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Programa*</mat-label>

                <input matInput formControlName="a4Programa" [matAutocomplete]="autoPrograma">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoPrograma="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of programaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Nombre Programa*</mat-label>

                <input matInput formControlName="a4NombrePrograma" [matAutocomplete]="autoNombrePrograma">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoNombrePrograma="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of nombreProgramaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Cuadrilla*</mat-label>

                <input matInput formControlName="a4Cuadrilla" [matAutocomplete]="autoCuadrilla">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoCuadrilla="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of cuadrillaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Beneficio*</mat-label>
                <input matInput formControlName="a4BeneficioPrograma">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Cantidad Entregada*</mat-label>
                <input matInput formControlName="a4CantidadEntregada">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Monto*</mat-label>
                <input matInput formControlName="a4MontoEntrega">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Costo Aproximado*</mat-label>
                <input matInput formControlName="a4CostoAproximado">
            </mat-form-field>
        </div>
    </div>
</form>
